module.exports = __webpack_public_path__ + "img/img2.b3f04a1e.svg";